import GIF from 'gif.js.optimized'
import { FRAME_DELAY } from '../constants'
import { CreationToolFrame } from '../types/index'

const CHILL_ZONE = {}

const checkIfSticker = (canvas: HTMLCanvasElement): boolean => {
    const context = canvas.getContext('2d')
    const imageData = context?.getImageData(0, 0, canvas.width, canvas.height)
    if (imageData && imageData.data) {
        const data = imageData.data
        let transparentPixels = 0
        for (let i = 0; i < data.length; i += 4) {
            const alpha = data[i + 3]
            if (alpha === 0) {
                transparentPixels++
            }
        }
        return transparentPixels > 0
    }
    return false
}

const getGifFromFrames = async (frames: CreationToolFrame[], cacheId?: string): Promise<File> =>
    new Promise((resolve, reject) => {
        if (cacheId && CHILL_ZONE[cacheId]) {
            return resolve(CHILL_ZONE[cacheId])
        }

        const { canvas } = frames[0]
        const isSticker = checkIfSticker(canvas)

        const gif = new GIF({
            workers: 4,
            workerScript: '/static/dist/workers/gif.worker.js',
            quality: 8,
            dither: 'FloydSteinberg',
            transparent: isSticker ? 0x00ff00 : undefined,
            height: canvas.height,
            width: canvas.width,
        })

        frames.forEach(({ canvas, frameCount = 1 }) => {
            let frame = canvas

            if (isSticker) {
                frame = document.createElement('canvas')
                const frameContext = frame.getContext('2d')
                frame.width = canvas.width
                frame.height = canvas.height
                if (frameContext) {
                    frameContext.fillStyle = '#00FF00'
                    frameContext.fillRect(0, 0, frame.width, frame.height)
                    frameContext.drawImage(canvas, 0, 0)
                }
            }

            gif.addFrame(frame, { delay: frameCount * FRAME_DELAY })
        })

        gif.on('finished', blob => {
            blob.lastModifiedDate = new Date()
            blob.name = 'giphy.gif'
            blob.accepted = true
            if (cacheId) {
                CHILL_ZONE[cacheId] = blob
            }
            resolve(blob)
        })

        gif.on('error', () => reject())
        gif.render()
    })

export default getGifFromFrames
